import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  IntegrationBenefits,
  Uninstall,
  ConnectWithKlaviyo,
} from "./components";
import { Klaviyo as KlaviyoIcon } from "../../../../assets";
import {
  ClassNames,
  getCookie,
  // getDataFromDb,
} from "../../../../helper";
import { FaAngleLeft } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../common/authenticateDashboard/authSlice";
import { getDataFromMongoDb } from "../../../../services/mongod.data";

const Klaviyo = () => {
  const sessionUser = useSelector(selectLogInUsername);
  const user = sessionUser?.split("@")[0];
  const [install, setInstall] = useState(false);
  const [integration, setIntegration] = useState(false);
  const [integrationData, setIntegrationData] = useState({});
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);

  const installHandler = (state) => setInstall(state);

  useEffect(() => {
    if (!integration) setIntegrationData({});
  }, [integration]);

  useEffect(() => {
    const fetchData = async () => {
      if (!user) return;
      try {
        // let api_url = `${user}/graph-integration/klaviyo`;
        // let result = await getDataFromDb(api_url);
        let apiData = await getDataFromMongoDb(user, "graph-integration");
        let result = apiData.data.klaviyo || apiData.data.data.klaviyo;
        if (result) {
          setIntegration(true);
          setIntegrationData(result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [user]);

  return (
    <div className="bg-gray-200 w-full p-3 relative">
      <NavLink
        to="/integration"
        className="text-indigo-600 text-lg text-semibold flex gap-1 items-center "
      >
        <FaAngleLeft className="text-sm" />
        Go back
      </NavLink>
      <div className="bg-white p-4 rounded-md my-2">
        <header className="flex flex-col md:flex-row pb-2 justify-between items-center border-bottom">
          <div className="my-3 flex items-center gap-3">
            <KlaviyoIcon className="text-3xl text-gray-500" />
            <p className="text-lg font-semibold">Klaviyo</p>
          </div>
          {integration && !install ? (
            <div className="space-x-2">
              <button
                className={ClassNames(
                  "text-gray-700 border p-1.5 rounded-md px-3.5 hover:cursor-pointer hover:bg-gray-100"
                )}
                onClick={() => setOpen(true)}
              >
                Uninstall
              </button>
              <button
                className={ClassNames(
                  "text-indigo-700 bg-indigo-200 p-1.5 rounded-md px-3.5 hover:bg-indigo-300 hover:cursor-pointer"
                )}
                onClick={() => setInstall(true)}
              >
                Configure
              </button>
            </div>
          ) : (
            <button
              className={ClassNames(
                "text-white bg-indigo-600 p-1.5 rounded-md px-3.5 hover:bg-indigo-500 hover:cursor-pointer",
                install ? "hidden" : ""
              )}
              onClick={() => setInstall(true)}
            >
              Install Klaviyo
            </button>
          )}
        </header>
        {install ? (
          <ConnectWithKlaviyo
            installHandler={installHandler}
            integrationData={integrationData}
            setIntegrationData={setIntegrationData}
            page={page}
            setPage={setPage}
            integration={integration}
            setIntegration={setIntegration}
          />
        ) : (
          <div className="relative">
            <Uninstall
              open={open}
              setOpen={setOpen}
              setIntegration={setIntegration}
            />
            <IntegrationBenefits />
          </div>
        )}
      </div>
    </div>
  );
};

export default Klaviyo;
